import { useQuery } from '@tanstack/react-query';
import { CompanyApi } from '../apis/company-api';
import { CustomerServiceApi } from '../apis/customer-service-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const DashboardQueries = {
  useLatestCompanies: () =>
    useQuery({
      queryKey: ['latestCompanies'],
      queryFn: async () => await CompanyApi.getLatestCompanies(),
      onError: () => CloseableErrorMessage('Error getting latest companies.'),
    }),

  useSalesforceDisabledCompanies: () => 
    useQuery({
      queryKey: ['salesforceCompanies'],
      queryFn: async () => await CompanyApi.getSalesforceDisabledCompanies(),
      onError: () => CloseableErrorMessage('Error getting Salesforce disabled companies')
    }),

  useProductStats: () => 
    useQuery({
      queryKey: ['productStats'],
      queryFn: async () => await CustomerServiceApi.getProductStats(),
      onError: () => CloseableErrorMessage('Error getting product stats')
    })
};
